import { ReservationsEndpoint } from '@constants/ApiEndpoints';
import { AxiosInstance } from 'axios';
import ReservationSummaryModel from 'models/Reservations/ReservationSummaryModel';
import { ReservationModel } from 'pages/ReservationModule/pages/CreateReservationPageNew/models';
import { ReservationPaymentMethodModel } from 'pages/ReservationModule/pages/CreateReservationPageNew/models/ReservationPaymentModel';
import { ReservationTargetEnum } from 'pages/ReservationModule/pages/CreateReservationPageNew/models/ReservationTargetEnum';

export type ReservationRequestModel =
  | (ReservationModel & { target: ReservationTargetEnum })
  | (ReservationPaymentMethodModel & { target: ReservationTargetEnum });

export interface ReservationSummaryServiceType {
  saveSummary: (data?: ReservationRequestModel) => Promise<ReservationSummaryModel>;
}

export const saveSummary =
  (axios: AxiosInstance) =>
  async (data?: ReservationRequestModel): Promise<ReservationSummaryModel> => {
    return await axios
      .post(ReservationsEndpoint.RESERVATION_SAVE_RESERVATION, { ...data })
      .then(({ data }) => {
        return data;
      });
  };
